import React from 'react'

import useElementInBounds from 'src/lib/js/hooks/useElementInBounds'

import NavContent from 'public/components/default_template/nav/NavContent'
import {
  RestaurantProfileRestaurantType,
  SimilarRxSearchResultRestaurantType
} from 'public/components/default_template/restaurant_profile/profileUtils'

import { resources } from 'config'

import RestaurantProfile from './restaurant_profile/RestaurantProfile'
import { BreadcrumbItem } from './restaurant_profile/breadcrumbs/Breadcrumbs'
import { OptionalToastLocalSiteData } from 'src/shared/js/types'

type RestaurantProfilePageProps = {
  restaurantProfileData: RestaurantProfileRestaurantType
  nearbyRxs?: SimilarRxSearchResultRestaurantType[]
  optionalSiteData?: OptionalToastLocalSiteData
  showOrderContent: boolean
  hideRXCarousel?: boolean
  hideFooter?: boolean
  logoSrc?: string
  logoLink?: string
  breadcrumbItems?: BreadcrumbItem[]
  useToastAppHeader?: boolean
}

export const RestaurantProfilePage = ({
  restaurantProfileData,
  nearbyRxs,
  optionalSiteData,
  showOrderContent,
  hideRXCarousel,
  hideFooter,
  logoSrc = '/icons/toast-logo-orange.svg',
  logoLink,
  breadcrumbItems,
  useToastAppHeader
}: RestaurantProfilePageProps) => {
  const [scrollNavRef, inBounds] = useElementInBounds<HTMLDivElement>({
    maxScrollY: 1
  })

  return (
    <div className='defaultTemplate'>
      <NavContent
        withCart={showOrderContent}
        withOOOptions
        navType='stickyNav'
        logoLink={logoLink ?? `https://${resources.toastLocalHost}/local`}
        logoLinkSameTab
        logoSrc={logoSrc}
        shouldShowPreviewBanner={false}
      />
      <RestaurantProfile
        restaurant={restaurantProfileData}
        nearbyRxs={nearbyRxs}
        optionalSiteData={optionalSiteData}
        scrollNavRef={scrollNavRef}
        usingSecondaryNav={inBounds}
        showOrderPage={showOrderContent}
        hideRXCarousel={hideRXCarousel}
        hideFooter={hideFooter}
        breadcrumbItems={breadcrumbItems}
        useToastAppHeader={useToastAppHeader}
      />
    </div>
  )
}

export default RestaurantProfilePage
